/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlockedUserResponse } from '../models/BlockedUserResponse';
import type { BlockUserRequest } from '../models/BlockUserRequest';
import type { PaginationInfo } from '../models/PaginationInfo';
import type { UserProfile } from '../models/UserProfile';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserManagementService {
    /**
     * List users
     * Get paginated list of all users. Only admin users can access this endpoint.
     * @returns any Users retrieved successfully
     * @throws ApiError
     */
    public static getUsers({
        page = 1,
        limit = 20,
    }: {
        /**
         * Page number for pagination
         */
        page?: number,
        /**
         * Number of items per page
         */
        limit?: number,
    }): CancelablePromise<{
        data?: Array<UserProfile>;
        pagination?: PaginationInfo;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users',
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized - Authentication required`,
                403: `Forbidden - Admin access required`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get current user profile
     * Get the profile information of the currently authenticated user
     * @returns UserProfile User profile retrieved successfully
     * @throws ApiError
     */
    public static getCurrentUser(): CancelablePromise<UserProfile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user',
            errors: {
                401: `Unauthorized - Authentication required`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update current user profile
     * Update the profile information of the currently authenticated user
     * @returns UserProfile User profile updated successfully
     * @throws ApiError
     */
    public static updateCurrentUser({
        requestBody,
    }: {
        requestBody: {
            /**
             * User email address
             */
            email?: string;
            /**
             * User full name
             */
            fullName?: string;
            /**
             * Current password (required if changing password)
             */
            currentPassword?: string;
            /**
             * New password (must contain minimum eight characters, at least one letter and one number)
             */
            newPassword?: string;
        },
    }): CancelablePromise<UserProfile> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Validation error`,
                401: `Unauthorized - Authentication required`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get user's email domain policy
     * Get the current user's email domain filtering policy for agent invitations
     * @returns any Email policy retrieved successfully
     * @throws ApiError
     */
    public static getUserEmailPolicy(): CancelablePromise<{
        /**
         * Policy ID
         */
        id?: string;
        /**
         * User ID
         */
        user_id?: string;
        /**
         * List of allowed email domains (must start with @)
         */
        allowed_domains?: Array<string>;
        /**
         * Whether the policy is active
         */
        is_active?: boolean;
        /**
         * Policy creation timestamp
         */
        created_at?: string;
        /**
         * Policy last update timestamp
         */
        updated_at?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/email-policy',
            errors: {
                401: `Unauthorized - Authentication required`,
                404: `No email policy found for the user`,
            },
        });
    }
    /**
     * Create or update user's email domain policy
     * Create or update the current user's email domain filtering policy for agent invitations
     * @returns any Email policy created or updated successfully
     * @throws ApiError
     */
    public static createOrUpdateUserEmailPolicy({
        requestBody,
    }: {
        requestBody: {
            /**
             * List of allowed email domains (must start with @ and be valid domain format)
             */
            allowed_domains: Array<string>;
        },
    }): CancelablePromise<{
        /**
         * Policy ID
         */
        id?: string;
        /**
         * User ID
         */
        user_id?: string;
        /**
         * List of allowed email domains
         */
        allowed_domains?: Array<string>;
        /**
         * Whether the policy is active
         */
        is_active?: boolean;
        /**
         * Policy creation timestamp
         */
        created_at?: string;
        /**
         * Policy last update timestamp
         */
        updated_at?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/email-policy',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized - Authentication required`,
            },
        });
    }
    /**
     * Delete user's email domain policy
     * Delete the current user's email domain filtering policy, allowing invitations from all domains
     * @returns void
     * @throws ApiError
     */
    public static deleteUserEmailPolicy(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/email-policy',
            errors: {
                401: `Unauthorized - Authentication required`,
                404: `No email policy found for the user`,
            },
        });
    }
    /**
     * Get specific user details
     * Get detailed information about a specific user. Only admin users can access this endpoint.
     * @returns UserProfile User details retrieved successfully
     * @throws ApiError
     */
    public static getUserById({
        userId,
    }: {
        /**
         * ID of the user to retrieve
         */
        userId: string,
    }): CancelablePromise<UserProfile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                401: `Unauthorized - Authentication required`,
                403: `Forbidden - Admin access required`,
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update user by admin
     * Update a specific user's information. Only admin users can perform this action.
     * @returns UserProfile User updated successfully
     * @throws ApiError
     */
    public static updateUserById({
        userId,
        requestBody,
    }: {
        /**
         * ID of the user to update
         */
        userId: string,
        requestBody: {
            /**
             * User email address
             */
            email?: string;
            /**
             * User full name
             */
            fullName?: string;
            /**
             * User active status
             */
            isActive?: boolean;
            /**
             * New password (must contain minimum eight characters, at least one letter and one number)
             */
            password?: string;
        },
    }): CancelablePromise<UserProfile> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/{user_id}',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Validation error`,
                401: `Unauthorized - Authentication required`,
                403: `Forbidden - Admin access required`,
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get user feature flags
     * Get feature flags for a specific user. Only admin users can access this endpoint.
     * @returns any User feature flags retrieved successfully
     * @throws ApiError
     */
    public static getUserFeatureFlags({
        userId,
    }: {
        /**
         * ID of the user to retrieve feature flags for
         */
        userId: string,
    }): CancelablePromise<{
        /**
         * User ID
         */
        user_id?: string;
        /**
         * Username
         */
        username?: string;
        /**
         * User's feature flags
         */
        feature_flags?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{user_id}/feature-flags',
            path: {
                'user_id': userId,
            },
            errors: {
                401: `Unauthorized - Authentication required`,
                403: `Forbidden - Admin access required`,
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update user feature flags
     * Update feature flags for a specific user. Only admin users can perform this action.
     * @returns any User feature flags updated successfully
     * @throws ApiError
     */
    public static updateUserFeatureFlags({
        userId,
        requestBody,
    }: {
        /**
         * ID of the user to update feature flags for
         */
        userId: string,
        requestBody: {
            /**
             * Feature flags to update (merges with existing flags)
             */
            feature_flags: Record<string, any>;
        },
    }): CancelablePromise<{
        /**
         * User ID
         */
        user_id?: string;
        /**
         * Username
         */
        username?: string;
        /**
         * Updated feature flags
         */
        feature_flags?: Record<string, any>;
        /**
         * Success message
         */
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/{user_id}/feature-flags',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Validation error`,
                401: `Unauthorized - Authentication required`,
                403: `Forbidden - Admin access required`,
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Block a user
     * Block a user by email or username to prevent them from sharing agents with you
     * @returns BlockedUserResponse User blocked successfully
     * @throws ApiError
     */
    public static blockUser({
        requestBody,
    }: {
        requestBody: BlockUserRequest,
    }): CancelablePromise<BlockedUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/block',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Validation error`,
                401: `Unauthorized access`,
                404: `User not found`,
                409: `User already blocked`,
            },
        });
    }
    /**
     * List blocked users
     * Get list of all users blocked by the current user
     * @returns BlockedUserResponse Blocked users retrieved successfully
     * @throws ApiError
     */
    public static listBlockedUsers({
        page = 1,
        limit = 20,
    }: {
        /**
         * Page number for pagination
         */
        page?: number,
        /**
         * Number of items per page
         */
        limit?: number,
    }): CancelablePromise<Array<BlockedUserResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/block',
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized access`,
            },
        });
    }
    /**
     * Unblock a user
     * Remove a user from the blocked list
     * @returns void
     * @throws ApiError
     */
    public static unblockUser({
        blockId,
    }: {
        /**
         * Block record ID
         */
        blockId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/block/{block_id}',
            path: {
                'block_id': blockId,
            },
            errors: {
                401: `Unauthorized access`,
                404: `Block record not found`,
            },
        });
    }
}
